export default __webpack_public_path__ + "static/Adamczewski-e9bad3b5b13face7879603f8719a072f.jpeg";